import { FC, useCallback, useEffect, useState } from 'react';

import { Button } from 'antd';
import { GoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useNavigate } from 'react-router-dom';
import { LOGIN_ROUTE } from 'routes/user-management/list';
import { t } from 'tools/i18n';
import { Form, Icon, Input, Label, Typography, message } from 'ui';
import { formRules } from 'utils/formRules';

import { useForgotPasswordMutation } from 'services/events/eventsApiService';

import { LOGIN_FORM_ENUM } from '../login/login.utils';
import s from './ForgotPassword.module.scss';

const toggleCaptchaBadge = (show: boolean) => {
  const badge = document.getElementsByClassName('grecaptcha-badge')[0];
  if (badge && badge instanceof HTMLElement) {
    badge.style.visibility = show ? 'visible' : 'hidden';
  }
};

const ForgotPassword: FC = () => {
  const navigate = useNavigate();
  const [token, setToken] = useState<string>();
  const [ForgotPassword, { isLoading }] = useForgotPasswordMutation();
  const goToLogin = () => {
    navigate(LOGIN_ROUTE);
  };

  useEffect(() => {
    toggleCaptchaBadge(true);
    return () => toggleCaptchaBadge(false);
  }, []);

  const onVerify = useCallback(
    (token) => {
      setToken(token);
    },
    [setToken],
  );

  const handleSubmit = async (values) => {
    const payload = { email: values.email, captchaResponse: token! };

    try {
      const res = await ForgotPassword(payload);

      if ('data' in res) {
        message.success(
          'If the email exists in our system, you will receive an email on how to reset your password on ShowsHappening.',
          5,
        );
        setTimeout(() => {
          navigate(LOGIN_ROUTE);
        }, 1500);
      } else if ('error' in res) {
        message.error('Something went wrong. Please try again later.', 5);
      }
    } catch (err) {
      // Handle unexpected errors
      console.error('Unexpected error:', err);
      message.error('An unexpected error occurred. Please try again.');
    }
  };
  return (
    <div className={s.wrapper}>
      <Form className={s.form} onFinish={(values) => handleSubmit(values)}>
        <Icon name="logo" width={170} height={24} />
        <Typography type="h4" className={s.text}>
          {t('auth_reset_password')}
        </Typography>
        <div style={{ width: '100%' }}>
          <Label required>Email</Label>
          <Form.Item
            fullWidth
            name={LOGIN_FORM_ENUM.EMAIL}
            validateFirst
            rules={[formRules.required, formRules.email]}>
            <Input name={LOGIN_FORM_ENUM.EMAIL} placeholder="mail@example.com" size="large" />
          </Form.Item>
        </div>
        <GoogleReCaptcha onVerify={onVerify} />

        <div style={{ display: 'flex', alignItems: 'center', gap: 16, width: '100%' }}>
          <Button
            loading={isLoading}
            htmlType="submit"
            className={s.reset}
            type="primary"
            block
            size="large">
            RESET
          </Button>
          <Button type="link" className={s.link} onClick={goToLogin}>
            CANCEL
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default ForgotPassword;
